export default "__VITE_ASSET__c76fc156__"